import React from "react";
import { InputErrorProps } from "./Input.types";
import { Error as StyledError } from "./Error.styles";

/**
 * Error message component for input validation
 */
export const Error = ({ children, className }: InputErrorProps) => (
  <StyledError className={className}>{children}</StyledError>
);
